/* eslint-disable indent */
/* eslint-disable multiline-ternary */
/* eslint-disable max-lines-per-function */
// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

// Component
import { FormElems, Alert } from '../../components/';

// Helpers
import {
    getPipeSeparateValue,
    segregatePgByConfig,
    getModesOptions,
    getId,
} from '../../utils/helperMethods';

const images =
    process.env.NODE_ENV !== 'test'
        ? require.context('../../static/images', true)
        : '';

const DetailsForm = ({
    data,
    savedPgs,
    onBack,
    previousPath,
    onConfig,
    onSubmit,
    errorMessage,
    onModeSwitch,
    isViewMode,
}) => {
    const { configuredPgs, nonConfiguredPgs } = segregatePgByConfig(data);
    return (
        <div className="pgconfig-list-form">
            <div className="pgconfig-tab card">
                <h2 className="tab-title">PG Configuration</h2>
                <div className="configuration-details">
                    {errorMessage ? (
                        <Alert customClass="error-msg">{errorMessage}</Alert>
                    ) : null}
                    {isEmpty(savedPgs) ? (
                        <Alert customClass="info-msg">
                            Please configure at least One Payment Gateway.
                        </Alert>
                    ) : null}
                    {configuredPgs && configuredPgs.length ? (
                        <>
                            <p className="config-type">Configured PG </p>
                            <ul
                                className="configured-pg"
                                id="configured-pg-section"
                            >
                                {configuredPgs.map(details => {
                                    const imgsrc = images(
                                        `./${details.imagesName}.png`
                                    );
                                    const cardSrc = details.cardImages
                                        ? images(`./${details.cardImages}.png`)
                                        : null;
                                    return (
                                        <li>
                                            <div className="detail-section">
                                                <div className="image-section">
                                                    <div className="image-wrap">
                                                        <img
                                                            src={imgsrc}
                                                            alt={details.name}
                                                            className="image"
                                                        />
                                                    </div>
                                                    <div className="pg-title">
                                                        <label>
                                                            {details.label}
                                                        </label>
                                                        <p>{details.name}</p>
                                                    </div>
                                                </div>
                                                <div className="status">
                                                    <FormElems.Switch
                                                        name={`${details.uniqueId}Status`}
                                                        labelField="label"
                                                        id={`${details.uniqueId}-status`}
                                                        options={getModesOptions(
                                                            details.uniqueId,
                                                            savedPgs
                                                        )}
                                                        valueField="value"
                                                        handleChange={values =>
                                                            onModeSwitch(
                                                                values,
                                                                details.uniqueId
                                                            )
                                                        }
                                                        isDisabled={true}
                                                    />
                                                </div>
                                            </div>
                                            <div className="sub-details">
                                                {/* <div className="date">
                                                    <label>Date</label>
                                                    <p>{details.date}</p>
                                                </div> */}
                                                <div className="network">
                                                    <label>Network</label>
                                                    <p>
                                                        {getPipeSeparateValue(
                                                            details.networks
                                                        )}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="footer">
                                                <ul className="card-images-list">
                                                    {details.cardImages ? (
                                                        <li>
                                                            <img
                                                                src={cardSrc}
                                                                alt="Supporting Cards"
                                                            />
                                                        </li>
                                                    ) : null}
                                                </ul>
                                                {!isViewMode &&(
                                                    <>
                                                <div className="edit-wrap">
                                                    <button
                                                        type="button"
                                                        id={`edit-${getId(
                                                            details.name
                                                        )}`}
                                                        className="link-button"
                                                        onClick={() =>
                                                            onConfig(
                                                                true,
                                                                details
                                                            )
                                                        }
                                                    >
                                                        Edit
                                                    </button>
                                                </div>
                                                </>
                                            )}
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        </>
                    ) : null}
                </div>
                <div className="configuration-details nonPg">
                    {nonConfiguredPgs && nonConfiguredPgs.length ? (
                        <>
                            <p className="config-type">Non Configured PG </p>
                            <ul
                                className="configured-pg not"
                                id="no-configured-pg-section"
                            >
                                {nonConfiguredPgs.map((details, ind) => {
                                    const imgsrc = images(
                                        `./${details.imagesName}.png`
                                    );
                                    const cardSrc = details.cardImages
                                        ? images(`./${details.cardImages}.png`)
                                        : null;
                                    return (
                                        <li key={ind}>
                                            <div className="detail-section">
                                                <div className="image-section">
                                                    <div className="image-wrap">
                                                        <img
                                                            src={imgsrc}
                                                            alt={details.name}
                                                            className="image"
                                                        />
                                                    </div>
                                                    <div className="pg-title">
                                                        <label>
                                                            {details.label}
                                                        </label>
                                                        <p>{details.name}</p>
                                                    </div>
                                                </div>
                                                <div className="sub-details">
                                                    <div className="network">
                                                        <label>Network</label>
                                                        <p>
                                                            {getPipeSeparateValue(
                                                                details.networks
                                                            )}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="footer">
                                                <ul className="card-images-list">
                                                    {details.cardImages ? (
                                                        <li>
                                                            <img
                                                                src={cardSrc}
                                                                alt="Supporting Cards"
                                                            />
                                                        </li>
                                                    ) : null}
                                                </ul>
                                                {!isViewMode && (
                                                    <button
                                                        id={`configure-${getId(
                                                            details.name
                                                        )}`}
                                                        type="button"
                                                        className="link-button"
                                                        onClick={() =>
                                                            onConfig(
                                                                false,
                                                                details
                                                            )
                                                        }
                                                    >
                                                        Configure
                                                    </button>
                                                )}
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        </>
                    ) : null}
                </div>
            </div>
            {!isViewMode && (
                <>
            <div className="form-section action">
                {previousPath ? (
                    <FormElems.Button
                        buttonType="secondary"
                        text="BACK"
                        id="back-btn"
                        type="button"
                        handleClick={onBack}
                        customClass="back-btn"
                    />
                ) : null}
                <FormElems.Button
                    buttonType="primary"
                    id="next-btn"
                    text="NEXT"
                    type="button"
                    isDisable={isEmpty(savedPgs)}
                    handleClick={onSubmit}
                />
            </div>
            </>
            )}
        </div>
    );
};

DetailsForm.propTypes = {
    data: PropTypes.object.isRequired,
    savedPgs: PropTypes.object,
    onModeSwitch: PropTypes.func,
    onBack: PropTypes.func,
    onConfig: PropTypes.func,
    onNext: PropTypes.func,
    onSubmit: PropTypes.func,
    errorMessage: PropTypes.string,
    previousPath: PropTypes.string,
    isViewMode: PropTypes.bool,
};

export default DetailsForm;
